/* eslint-disable no-else-return */
import { getCookie } from "@insite/client-framework/Common/Cookies";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import Logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getCategoriesDataView,
    getCategoryDepthLoaded,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import {
    getPageLinkByNodeId,
    getPageLinkByPageType,
    useGetLink,
    useGetLinks,
} from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StylesContext } from "@insite/content-library/additionalStyles";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import SearchInput, { SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import { IconProps } from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { PopoverPresentationProps, PositionStyle } from "@insite/mobius/Popover";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import setAllWebSitePages from "@tecumseh/Handlers/CustomPageLinksHandler";
import getRoleBaseWebsitePages from "@tecumseh/Handlers/RoleBasePageHandler";
import MainNavigationItem from "@tecumseh/Overrides/Components/MainNavigationItem";
import NavigationDrawer from "@tecumseh/Overrides/Components/NavigationDrawer";
import CustomApplicationState from "@tecumseh/Store/Data/CustomApplicationState/CustomApplicationState";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import * as cssLinter from "css";
import isEqual from "lodash/isEqual";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";
// eslint-disable-next-line spire/fenced-imports
import { TS } from "@insite/shell/TS";

const enum fields {
    links = "links",
    website = "website",
    showQuickOrder = "showQuickOrder",
    openParentPages = "openParentPages",
    showSeperatorForLastElem = "showSeperatorForLastElem",
    customCSS = "customCSS",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
        [fields.website]: string;
        [fields.showQuickOrder]: boolean;
        [fields.openParentPages]: boolean;
        [fields.showSeperatorForLastElem]: boolean;
        [fields.customCSS]: string;
    };
    isCompactHeaderFlyoutMenu: boolean;
    flyoutCustomCSS?: string;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    isCompactHeaderMainNavigation: boolean;
    сompactHeaderMainNavigationCustomCSS?: string;
}

interface LinkModel {
    fields: {
        openInNewWindow: boolean;
        destination: LinkFieldValue;
        linkType: "Link" | "MegaMenu" | "CascadingMenu";
        overrideTitle: string;
        title: string;
        numberOfColumns: number;
        maxDepth: number;
        isBackground: boolean;
        isDcProduct: boolean;
        customMenuTitle: string;
        isCustomMenu: boolean;
        subMenuLinks: SubMenuLink[];
        flyoutContainerWidth?: number;
        childLinks?: LinkModel[];
        titleLink?: LinkFieldValue;
        parentTitle?: string;
    };
}
export interface SubMenuLink {
    fields: Fields;
    children?: InternalMenuLink[];
}
export interface Fields {
    subMenuTitle: string;
    destination: Destination2;
    openInNewWindow?: boolean;
    colWidth?: number;
    internalMenuLinks: InternalMenuLink[];
}
export interface Destination2 {
    type: string;
    value: string;
}
export interface InternalMenuLink {
    fields: Fields2;
}
export interface Fields2 {
    internalMenuTitle: string;
    destination: Destination3;
    openInNewWindow?: boolean;
}
export interface Destination3 {
    type: string;
    value: string;
}
export interface MappedLink {
    id?: string;
    title: string;
    url: string;
    type?: string;
    excludeFromNavigation?: boolean;
    openInNewWindow?: boolean;
    numberOfColumns?: number;
    maxDepth?: number;
    smallImagePath?: string;
    childrenType?: "MegaMenu" | "CascadingMenu" | "CustomLinkList";
    children?: MappedLink[];
    isBackground?: boolean;
    isDcProduct?: boolean;
    customMenuTitle?: string;
    isCustomMenu?: boolean;
    subMenuLinks?: SubMenuLink[];
    colWidth?: number;
    flyoutContainerWidth?: number;
}

const mapStateToProps = (state: ApplicationState & CustomApplicationState, ownProps: OwnProps) => {
    const {
        fields: { links = [] },
    } = ownProps;
    const mappedLinks = [];
    const categoryIdsToLoad: Dictionary<number> = {};
    const userRoles = state.context.session?.userRoles?.split(",");
    const roleBasePages = state.TECData.roleBasePages.contentResults;
    const isLoadingRoleBasePage = state.TECData.roleBasePages.isLoadingRoleBasePage;
    const isAuthenticated = state.context.session?.isAuthenticated && !state.context.session?.isGuest;
    for (const link of links) {
        const {
            fields: {
                linkType,
                destination,
                openInNewWindow,
                overrideTitle,
                numberOfColumns,
                flyoutContainerWidth,
                maxDepth,
                title,
                isBackground,
                isDcProduct,
                isCustomMenu,
                customMenuTitle,
                subMenuLinks,
            },
        } = link;
        const { type, value } = destination;

        const depthToLoad = linkType === "MegaMenu" ? 2 : maxDepth;

        let mappedLink: MappedLink | undefined;

        if (type === "Url") {
            mappedLink = {
                url: value,
                title,
            };
        } else if (type === "Page") {
            const readonlyPageLink = getPageLinkByNodeId(state, value);
            if (readonlyPageLink) {
                mappedLink = { ...readonlyPageLink };
                if (overrideTitle) {
                    mappedLink.title = overrideTitle;
                }
            }
        } else if (type === "Category") {
            mappedLink = setupCategoryLink(
                state,
                value,
                categoryIdsToLoad,
                depthToLoad,
                overrideTitle,
                state.data.categories.categoryIdsCalled,
            );
        }

        // if (linkType === "CascadingMenu" && (link.fields as unknown as any).isCustomMenu) {
        //     const customSubLinks = useGetLinks(link.fields.subMenuLinks, o => o.fields.destination);

        //     const children = link.fields.subMenuLinks.map((pLink) => ({
        //         url: pLink.fields.destination,
        //         title: pLink.fields.subMenuTitle,
        //     }));

        //     // eslint-disable-next-line no-console
        //     console.log("link.fields: ", link.fields);
        //     mappedLink = {
        //         url: link.fields.destination.value,
        //         title: link.fields.overrideTitle,
        //         children,
        //     };
        // }

        if (!mappedLink) {
            continue;
        }

        mappedLink.openInNewWindow = openInNewWindow;
        mappedLink.numberOfColumns = numberOfColumns;
        mappedLink.flyoutContainerWidth = flyoutContainerWidth;
        mappedLink.maxDepth = maxDepth;
        mappedLink.isBackground = isBackground;
        mappedLink.isDcProduct = isDcProduct;

        const subMenuMappedLinks: MappedLink[] = [] as MappedLink[];

        if (linkType === "MegaMenu" || linkType === "CascadingMenu") {
            mappedLink.childrenType = linkType;
            if (linkType === "MegaMenu" && isCustomMenu) {
                // eslint-disable-next-line array-callback-return
                subMenuLinks.map(o => {
                    let subMenuMappedLink: any;
                    const internalSubMenuMappedLinks: MappedLink[] = [] as MappedLink[];

                    let internalMenuMappedLink: any | undefined = [];

                    const { type, value } = o.fields.destination;
                    if (type === "Url") {
                        subMenuMappedLink = {
                            url: value,
                            title: o.fields.subMenuTitle,
                            openInNewWindow: o.fields.openInNewWindow,
                        };
                    } else if (type === "Page") {
                        const readonlyPageLink = getPageLinkByNodeId(state, value);

                        if (readonlyPageLink) {
                            subMenuMappedLink = { ...readonlyPageLink };
                            if (overrideTitle) {
                                subMenuMappedLink.title = o.fields.subMenuTitle;
                            }
                            if (subMenuMappedLink) {
                                subMenuMappedLink = {
                                    url: subMenuMappedLink.url,
                                    openInNewWindow: o.fields.openInNewWindow,
                                    title: o.fields.subMenuTitle,
                                    id: subMenuMappedLink.id,
                                };
                            }
                        }
                    } else if (type === "Category") {
                        subMenuMappedLink = setupCategoryLink(
                            state,
                            value,
                            categoryIdsToLoad,
                            depthToLoad,
                            o.fields.subMenuTitle,
                            state.data.categories.categoryIdsCalled,
                        );
                        if (subMenuMappedLink) {
                            subMenuMappedLink = {
                                ...subMenuMappedLink,
                                title: o.fields.subMenuTitle,
                                openInNewWindow: o.fields.openInNewWindow,
                            };
                        }
                    }

                    // eslint-disable-next-line array-callback-return
                    o.fields.internalMenuLinks.map(p => {
                        const { type, value } = p.fields.destination;
                        if (type === "Url") {
                            internalMenuMappedLink = {
                                url: value,
                                title: p.fields.internalMenuTitle,
                                openInNewWindow: p.fields.openInNewWindow,
                            };
                        } else if (type === "Page") {
                            const readonlyPageLink = getPageLinkByNodeId(state, value);
                            if (readonlyPageLink) {
                                internalMenuMappedLink = { ...readonlyPageLink };
                                if (overrideTitle) {
                                    internalMenuMappedLink.title = p.fields.internalMenuTitle;
                                }
                                if (internalMenuMappedLink) {
                                    internalMenuMappedLink = {
                                        url: internalMenuMappedLink.url,
                                        title: p.fields.internalMenuTitle,
                                        openInNewWindow: p.fields.openInNewWindow,
                                        id: internalMenuMappedLink.id,
                                    };
                                }
                            }
                        } else if (type === "Category") {
                            internalMenuMappedLink = setupCategoryLink(
                                state,
                                value,
                                categoryIdsToLoad,
                                depthToLoad,
                                p.fields.internalMenuTitle,
                                state.data.categories.categoryIdsCalled,
                            );
                            if (internalMenuMappedLink) {
                                internalMenuMappedLink = {
                                    ...internalMenuMappedLink,
                                    title: p.fields.internalMenuTitle,
                                    openInNewWindow: p.fields.openInNewWindow,
                                };
                            }
                        }

                        if (internalMenuMappedLink) {
                            internalSubMenuMappedLinks.push(internalMenuMappedLink);
                        }
                    });

                    if (subMenuMappedLink) {
                        if (subMenuMappedLink) {
                            subMenuMappedLink["children"] = subMenuMappedLink["children"]
                                ? internalSubMenuMappedLinks
                                : internalSubMenuMappedLinks;
                            subMenuMappedLink["colWidth"] = o.fields.colWidth;
                            subMenuMappedLinks.push(subMenuMappedLink);
                        }
                    }
                });
                const children = mappedLink.children ? subMenuMappedLinks : mappedLink.children;
                mappedLink["children"] = children;
            }
            if (linkType === "CascadingMenu" && isCustomMenu) {
                subMenuLinks.forEach(o => {
                    let subMenuMappedLink: any;
                    const internalSubMenuMappedLinks: MappedLink[] = [] as MappedLink[];

                    let internalMenuMappedLink: any | undefined = [];

                    const { type, value } = o.fields.destination;
                    if (type === "Url") {
                        subMenuMappedLink = {
                            url: value,
                            title: o.fields.subMenuTitle,
                            openInNewWindow: o.fields.openInNewWindow,
                        };
                    } else if (type === "Page") {
                        const readonlyPageLink = getPageLinkByNodeId(state, value);
                        if (readonlyPageLink) {
                            subMenuMappedLink = { ...readonlyPageLink };
                            if (overrideTitle) {
                                subMenuMappedLink.title = o.fields.subMenuTitle;
                            }
                            if (subMenuMappedLink) {
                                subMenuMappedLink = {
                                    url: subMenuMappedLink.url,
                                    openInNewWindow: o.fields.openInNewWindow,
                                    title: o.fields.subMenuTitle,
                                    id: subMenuMappedLink.id,
                                };
                            }
                        }
                    } else if (type === "Category") {
                        subMenuMappedLink = setupCategoryLink(
                            state,
                            value,
                            categoryIdsToLoad,
                            depthToLoad,
                            o.fields.subMenuTitle,
                            state.data.categories.categoryIdsCalled,
                        );
                        if (subMenuMappedLink) {
                            subMenuMappedLink = {
                                ...subMenuMappedLink,
                                title: o.fields.subMenuTitle,
                                openInNewWindow: o.fields.openInNewWindow,
                            };
                        }
                    }

                    // eslint-disable-next-line array-callback-return
                    o.fields.internalMenuLinks.map(p => {
                        const { type, value } = p.fields.destination;
                        if (type === "Url") {
                            internalMenuMappedLink = {
                                url: value,
                                title: p.fields.internalMenuTitle,
                                openInNewWindow: p.fields.openInNewWindow,
                            };
                        } else if (type === "Page") {
                            const readonlyPageLink = getPageLinkByNodeId(state, value);
                            if (readonlyPageLink) {
                                internalMenuMappedLink = { ...readonlyPageLink };
                                if (overrideTitle) {
                                    internalMenuMappedLink.title = p.fields.internalMenuTitle;
                                }
                                if (internalMenuMappedLink) {
                                    internalMenuMappedLink = {
                                        url: internalMenuMappedLink.url,
                                        title: p.fields.internalMenuTitle,
                                        openInNewWindow: p.fields.openInNewWindow,
                                        id: internalMenuMappedLink.id,
                                    };
                                }
                            }
                        } else if (type === "Category") {
                            internalMenuMappedLink = setupCategoryLink(
                                state,
                                value,
                                categoryIdsToLoad,
                                depthToLoad,
                                p.fields.internalMenuTitle,
                                state.data.categories.categoryIdsCalled,
                            );
                            if (internalMenuMappedLink) {
                                internalMenuMappedLink = {
                                    ...internalMenuMappedLink,
                                    title: p.fields.internalMenuTitle,
                                    openInNewWindow: p.fields.openInNewWindow,
                                };
                            }
                        }

                        if (internalMenuMappedLink) {
                            internalSubMenuMappedLinks.push(internalMenuMappedLink);
                        }
                    });

                    if (subMenuMappedLink) {
                        if (subMenuMappedLink) {
                            subMenuMappedLink["children"] = subMenuMappedLink["children"]
                                ? internalSubMenuMappedLinks
                                : internalSubMenuMappedLinks;
                            subMenuMappedLink["colWidth"] = o.fields.colWidth;
                            subMenuMappedLinks.push(subMenuMappedLink);
                        }
                    }
                });
                const children = mappedLink.children
                    ? [...mappedLink.children, ...subMenuMappedLinks]
                    : mappedLink.children;
                mappedLink["children"] = children;
            }
        }
        mappedLinks.push(mappedLink);
    }

    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    const { orderSettings } = getSettingsCollection(state);
    const session = getSession(state);

    const isVmiAdmin = session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1;
    const isVmiUser = session.userRoles?.toLowerCase().indexOf("vmi_user") !== -1;

    // const USER_ROLES = userRoles?.map((role) => role && role.trim().toLowerCase());
    // const checkUserRoles = (role: string) => {
    //     return role && USER_ROLES.includes(role.toLowerCase());
    // }

    // const getPage = (id: string) => {
    //     const page = roleBasePages.filter((rPage) => rPage.nodeId === id)
    //     return page.length > 0 ? page[0]: null;
    // }

    // let filteredLinks: any = [];
    // const mapping = JSON.stringify(mappedLinks);
    // const filterObject = (mainObj: any) => {
    //     return mainObj?.filter((obj: any) => {
    //         const page = getPage(obj?.id);
    //         if(!(obj?.id)) {
    //             obj.children = filterObject(obj.children);
    //             return true;
    //         } else if (!page && obj?.children?.length > 0) {
    //             obj.children = filterObject(obj.children);
    //             return obj?.children?.length > 0;
    //         } else if (page && checkUserRoles(page.userRole)) {
    //             return true;
    //         } else if (page && obj?.children?.length > 0) {
    //             obj.children = filterObject(obj.children);
    //             return obj?.children?.length > 0;
    //         }
    //         return false;
    //     });
    // };

    // if(roleBasePages.length) {
    // filteredLinks = filterObject(JSON.parse(mapping));
    // }

    return {
        links: mappedLinks,
        quickOrderLink: getPageLinkByPageType(state, "QuickOrderPage"),
        categoryIdsToLoad,
        allowQuickOrder: orderSettings.allowQuickOrder,
        categoryErrorStatusCodeById: state.data.categories.errorStatusCodeById,
        categoryIdsCalled: state.data.categories.categoryIdsCalled,
        displayChangeCustomerLink: session?.displayChangeCustomerLink,
        displayVmiNavigation:
            currentMode === "Vmi" && orderSettings.vmiEnabled && isAuthenticated && (isVmiAdmin || isVmiUser),
        displayModeSwitch: isAuthenticated && orderSettings.vmiEnabled && (isVmiAdmin || isVmiUser),
        currentMode,
        vmiPageLinks: isVmiAdmin
            ? [
                  getPageLinkByPageType(state, "VmiDashboardPage"),
                  getPageLinkByPageType(state, "VmiLocationsPage"),
                  getPageLinkByPageType(state, "VmiUsersPage"),
                  getPageLinkByPageType(state, "VmiBinsPage"),
                  getPageLinkByPageType(state, "VmiReportingPage"),
                  getPageLinkByPageType(state, "VmiOrderHistoryPage"),
              ]
            : isVmiUser
              ? [
                    getPageLinkByPageType(state, "VmiDashboardPage"),
                    getPageLinkByPageType(state, "VmiLocationsPage"),
                    getPageLinkByPageType(state, "VmiBinsPage"),
                    getPageLinkByPageType(state, "VmiReportingPage"),
                    getPageLinkByPageType(state, "VmiOrderHistoryPage"),
                ]
              : [],
        isAuthenticated,
        isLoadingRoleBasePage,
        userRoles,
        roleBasePages,
        originalLinks: mappedLinks,
    };
};

const getParameter = (categoryId: string, maxDepth: number) => ({
    maxDepth,
    startCategoryId: categoryId === emptyGuid ? undefined : categoryId,
    includeStartCategory: categoryId !== emptyGuid,
    expand: ["properties"],
});

const setupCategoryLink = (
    state: ApplicationState,
    value: string,
    categoryIdsToLoad: Dictionary<number>,
    maxDepth: number,
    overrideTitle: string,
    categoryIdsCalled: string[],
) => {
    let mappedLink: MappedLink | undefined;

    if (!value) {
        return;
    }

    const depthLoaded = getCategoryDepthLoaded(state, value);
    const subCategoryIds = getSubCategoryIds(state, value);
    if (
        (depthLoaded < maxDepth || (!subCategoryIds && !categoryIdsCalled?.includes(value))) &&
        !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
    ) {
        categoryIdsToLoad[value] = maxDepth;
    } else {
        if (value === emptyGuid) {
            mappedLink = {
                url: "",
                title: overrideTitle || translate("Products"),
            };
        } else {
            const categoryState = getCategoryState(state, value);
            if (!categoryState.value) {
                if (
                    !categoryState.isLoading &&
                    !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
                ) {
                    categoryIdsToLoad[value] = maxDepth;
                }
                return;
            }
            mappedLink = {
                url: categoryState.value.path,
                title: overrideTitle || categoryState.value.shortDescription,
            };
        }

        loadSubCategories(mappedLink, subCategoryIds, 1, maxDepth, state);
    }

    return mappedLink;
};

const loadSubCategories = (
    mappedLink: MappedLink,
    subCategoryIds: readonly string[] | undefined,
    currentDepth: number,
    maxDepth: number,
    state: ApplicationState,
) => {
    if (currentDepth > maxDepth) {
        return;
    }
    mappedLink.children = [];
    if (!subCategoryIds) {
        return;
    }
    for (const subCategoryId of subCategoryIds) {
        const subCategory = getCategoryState(state, subCategoryId).value;
        if (!subCategory) {
            Logger.error(`Category ${subCategoryId} was not found in data state, excluding from navigation.`);
            continue;
        }
        const childLink: MappedLink = {
            url: subCategory.path,
            title: subCategory.shortDescription,
            smallImagePath: subCategory.smallImagePath,
            children: [],
        };
        mappedLink.children.push(childLink);

        loadSubCategories(childLink, subCategory.subCategoryIds, currentDepth + 1, maxDepth, state);
    }
};

const mapDispatchToProps = {
    loadCategories,
    getRoleBaseWebsitePages,
    setAllWebSitePages,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface State {
    selectedLinkIndex?: number;
    mobileSearchModalIsOpen: boolean;
}

export interface MainNavigationStyles {
    menuHeight: number;
    container?: InjectableCss;
    itemWrapper?: InjectableCss;
    quickOrderItemWrapper?: InjectableCss;
    menuItem?: InjectableCss;
    menuItemIcon?: IconProps;
    menuItemTypography?: TypographyPresentationProps;
    cascadingMenu?: MenuPresentationProps;
    megaMenu?: PopoverPresentationProps;
    megaMenuGridContainer?: GridContainerProps;
    megaMenuGridItem?: GridItemProps;
    megaMenuHeading?: LinkPresentationProps;
    megaMenuLink?: LinkPresentationProps;
    mobileWrapper?: InjectableCss;
    compactFlyoutMenu?: InjectableCss;
    mobileMenuWrapper?: InjectableCss;
    mobileSearchButton?: ButtonPresentationProps;
    mobileSearchWrapper?: InjectableCss;
    mobileSearchModal?: ModalPresentationProps;
    mobileSearchInputWrapper?: InjectableCss;
    mobileSearchInputStyles?: SearchInputStyles;
    mobileSearchModalCloseIcon?: IconProps;
    contentWrapper?: InjectableCss;
    mainWrapper?: InjectableCss;
}

export const mainNavigationStyles: MainNavigationStyles = {
    menuHeight: 50,
    mainWrapper: {
        css: css`
            max-width: 1200px;
            margin: 0 auto;
        `,
    },
    container: {
        css: css`
            color: ${getColor("common.background")};
            display: flex;
            justify-content: left;
            position: relative;
            background-color: ${getColor("primary")};
            &:before {
                content: "";
                position: absolute;
                left: -500%;
                width: 500%;
                height: 100%;
                background-color: ${getColor("primary")};
            }
        `,
    },
    itemWrapper: {
        css: css`
            align-items: center;
            justify-content: flex-start;
            position: relative;
            overflow: visible;
            display: flex;
            padding: 0 32px;
            &:hover span + div {
                display: block;
            }
            &:after {
                content: "";
                height: 60%;
                width: 1px;
                right: 0;
                top: 10px;
                margin-left: 35px;
                margin-right: 35px;
                background-color: ${COLORS.background.base};
            }
            &.item-wrapper__last::after {
                display: none !important;
            }

            // &:last-child:after {
            //     display: none;
            // }
        `,
    },
    quickOrderItemWrapper: {
        css: css`
            margin-left: auto;
            margin-right: 0;
        `,
    },
    megaMenuGridItem: {
        css: css`
            display: block;
            padding: 5px 15px;
        `,
    },
    megaMenuHeading: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            letter-spacing: ${TYPOGRAPHY.letterSpacing.smallish};
            span {
                color: ${getColor("secondary")} !important;
                &:hover {
                    color: ${getColor("primary")} !important;
                }
            }
        `,
    },
    megaMenuLink: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smallest};
            font-weight: ${TYPOGRAPHY.weight.base};
            letter-spacing: ${TYPOGRAPHY.letterSpacing.vSmall};
            padding: 5px 0;
            span {
                color: ${COLORS.black} !important;
                line-height: 19px;
                &:hover {
                    color: ${COLORS.secondaryNavyOne} !important;
                }
            }
        `,
    },
    menuItem: {
        css: css`
            display: flex;
            align-items: center;
            height: 50px;
            line-height: 50px;
            > span {
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            &[aria-expanded="true"] {
                ::after {
                    content: "";
                    width: 0;
                    height: 0;
                    border-left: 15px solid transparent;
                    border-right: 15px solid transparent;
                    border-bottom: 15px solid ${COLORS.lighterGrayShade};
                    position: absolute;
                    bottom: 0px;
                    left: 0px;
                }
            }
            &:hover {
                span {
                    color: ${COLORS.white} !important;
                }
                svg {
                    color: ${COLORS.white} !important;
                }
            }
        `,
    },
    menuItemIcon: {
        css: css`
            margin: -3px 0 0 10px;
        `,
        size: 18,
        color: "secondary.contrast",
    },
    menuItemTypography: {
        variant: "headerSecondary",
        color: "secondary.contrast",
        css: css`
            font-weight: 400;
            font-size: ${TYPOGRAPHY.size.smaller};
            letter-spacing: ${TYPOGRAPHY.letterSpacing.smaller};
        `,
    },
    megaMenu: {
        transitionDuration: "short",
        contentBodyProps: {
            _height: "1200px",
            css: css`
                padding: 20px 30px;
                background-color: ${COLORS.background.lighterGrayShade};
            `,
        },
    },
    mobileSearchButton: {
        size: 48,
        css: css`
            padding: 0 10px;
            border: none;
            background: none;
            svg {
                path {
                    /* fill: ${COLORS.primaryBlue}; */
                    fill: ${getColor("primary")};
                }
            }
        `,
    },
    mobileWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            flex-direction: row-reverse;
        `,
    },
    contentWrapper: {
        css: css``,
    },
    compactFlyoutMenu: {
        css: css`
            & button {
                background: transparent;
                border: none;
                &:hover {
                    background: ${COLORS.background.black};
                }

                svg {
                    color: ${props => resolveColor(props.theme.header.linkColor, props.theme)};
                }
            }
        `,
    },
    mobileSearchWrapper: {
        css: css`
            text-align: right;
        `,
    },
    mobileMenuWrapper: {
        css: css`
            text-align: right;
            > button[data-test-selector="expandMobileMenu"] {
                background-color: ${COLORS.white};
                padding: 0px 10px 0 10px;
                margin-right: 5px;
                border: none;
                > span[class^="IconWrapper"] {
                    color: ${getColor("primary")};
                    > svg {
                        width: 25px;
                    }
                }
            }
        `,
    },
    mobileSearchInputWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    mobileSearchInputStyles: {
        input: {
            cssOverrides: {
                formField: css`
                    width: 100%;
                `,
            },
        },
        popover: {
            wrapperProps: {
                css: css`
                    width: calc(100% - 45px);
                `,
            },
        },
        popoverContentBody: {
            as: "div",
            _height: "100%",
            css: css`
                box-shadow: none;
            `,
        },
        autocompleteWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
            `,
        },
        autocompleteColumnWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                width: 100%;
                padding: 0 50px 0 30px;
            `,
        },
        searchHistoryStyles: {
            wrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    padding: 0 50px 15px 30px;
                `,
            },
        },
        autocompleteProductsStyles: {
            titleLink: {
                css: css`
                    width: 100%;
                `,
            },
            erpNumberText: {
                css: css`
                    width: 100%;
                    text-align: left;
                    margin: 5px 0 0 0;
                `,
            },
        },
    },
    mobileSearchModalCloseIcon: {
        src: X,
        size: 18,
        css: css`
            margin-left: 10px;
        `,
    },
};

const defaultCustomCss = `.mobile-wrapper {
}

.mobile-menu-wrapper {
}

.menu-trigger-button {
}

.menu-trigger-button-icon {
}

.drawer {
}

.drawer-section-wrapper {
}

.currency-selector-wrapper {
}
.language-selector-wrapper {
}

.panel-menu {
}

.main-navigation-row {
}

.panel-section-wrapper {
}

.main-navigation-row-icon {
}

.user-row-text {
}

.punch-out-navigation-row-icon {
}

.punch-out-user-row-text {
}

.main-navigation-row-text {
}

.logo-links-row {
}

.logo-link-title {
}

.language-image {
}

.menu-row-icon {
}

.change-customer-row {
}

.change-customer-row-container {
}

.fulfillment-method-grid-item {
}

.addresses-grid-item {
}

.pick-up-address-grid-item {
}

.apply-button-grid-item {
}

.sign-out-row {
}

.sign-out-row-text {
}

.mobile-search-wrapper {
}

.mobile-search-button {
}

.mobile-search-button-icon {
}

.container {
}



.item-wrapper {
}

.cascading-menu {
}

.menu-item {
}

.mega-menu {
}

.mega-menu-grid-container {
}

.mega-menu-grid-item {
}

.mega-menu-heading-link {
}

.mega-menu-link {
}

.quick-order-item-wrapper {
}

.quick-order-link {
}

.vmi-page-link {
}

.mobile-search-modal {
}`;

export const StyledWrapperContainer = styled.div<{ website?: string }>`
    color: ${getColor("common.background")};
    display: flex;
    justify-content: left;
    position: relative;
    background-color: ${getColor("primary")};
    &:before {
        content: "";
        position: absolute;
        left: -500%;
        width: 500%;
        height: 100%;
        background-color: ${({ website }) => (website === "tecumseh" ? getColor("primary") : getColor("secondary"))};
    }
`;
export class MainNavigation extends React.Component<Props, State> {
    container = React.createRef<HTMLDivElement | null>();
    mobileSearchInput = React.createRef<HTMLInputElement>();
    declare context: React.ContextType<typeof StylesContext>;

    constructor(props: Props) {
        super(props);

        this.state = {
            mobileSearchModalIsOpen: false,
        };
    }

    UNSAFE_componentWillMount(): void {
        this.loadCategoriesIfNeeded();

        setMainNavigation({
            close: () => {
                this.setState({
                    selectedLinkIndex: undefined,
                });
            },
            openMenu: (index: number) => {
                this.setState({
                    selectedLinkIndex: index,
                });
            },
        });
    }

    checkUserRoles(role: any) {
        const USER_ROLES = this.props.userRoles?.map((role: string) => role && role.trim().toLowerCase());
        return role && USER_ROLES && USER_ROLES.includes(role.toLowerCase());
    }

    getPage(id: string, roleBasePages: any) {
        const page = roleBasePages.filter((rPage: any) => rPage.nodeId === id);
        return page.length > 0 ? page[0] : null;
    }

    filterObject(mainObj: any, roleBasePages: any) {
        return mainObj?.filter((obj: any) => {
            const page = this.getPage(obj?.id, roleBasePages);
            if (!obj?.id && obj?.children?.length > 0) {
                obj.children = this.filterObject(obj.children, roleBasePages);
                return obj?.children?.length > 0;
            } else if (!page && obj?.children?.length > 0) {
                obj.children = this.filterObject(obj.children, roleBasePages);
                return obj?.children?.length > 0;
            } else if (page && this.checkUserRoles(page.userRole)) {
                return true;
            } else if (page && obj?.children?.length > 0) {
                obj.children = this.filterObject(obj.children, roleBasePages);
                return obj?.children?.length > 0;
            }
            return false;
        });
    }

    componentDidMount(): void {
        // this.props.getRoleBaseWebsitePages({
        //     onSuccess: (results) => {
        //         const _links = JSON.stringify(this.props.originalLinks);
        //         const authLinks = this.filterObject(JSON.parse(_links), results);
        //         this.props.setAllWebSitePages({
        //             allPages: authLinks
        //         });
        //     }
        // });
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (!isEqual(this.props.categoryIdsToLoad, prevProps.categoryIdsToLoad)) {
            this.loadCategoriesIfNeeded(true);
        }
    }

    loadCategoriesIfNeeded(isComponentDidUpdate = false) {
        const { categoryIdsToLoad } = this.props;
        for (const categoryId of Object.keys(categoryIdsToLoad)) {
            if (!this.props.categoryErrorStatusCodeById?.[categoryId]) {
                const maxDepth = categoryIdsToLoad[categoryId];
                if (!this.props.categoryIdsCalled?.includes(categoryId) || isComponentDidUpdate) {
                    this.props.loadCategories(getParameter(categoryId, maxDepth));
                }
            }
        }
    }

    getMobileSearchAutocompletePosition = (element: React.RefObject<HTMLUListElement | null>) => {
        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top = rect.top + rect.height;
            positionStyle.left = 0;
            positionStyle.width = `${document.documentElement.clientWidth}px`;
            positionStyle.height = `${document.documentElement.clientHeight - positionStyle.top}px`;
        }

        return positionStyle;
    };

    mobileSearchButtonClickHandler = () => {
        this.setState({ mobileSearchModalIsOpen: true }, () => {
            setTimeout(() => {
                if (this.mobileSearchInput?.current) {
                    this.mobileSearchInput.current.focus();
                    this.mobileSearchInput.current.click();
                }
            }, 250);
        });
    };

    mobileSearchModalCloseHandler = () => {
        this.setState({ mobileSearchModalIsOpen: false });
    };

    render() {
        const {
            links,
            quickOrderLink,
            fields: { website, showQuickOrder, showSeperatorForLastElem, openParentPages, customCSS },
            id,
            allowQuickOrder,
            isCompactHeaderFlyoutMenu,
            flyoutCustomCSS,
            showFlyoutPricingToggle,
            showFlyoutInventoryToggle,
            isCompactHeaderMainNavigation,
            сompactHeaderMainNavigationCustomCSS,
            vmiPageLinks,
            displayVmiNavigation,
            displayModeSwitch,
            currentMode,
        } = this.props;
        const { selectedLinkIndex } = this.state;

        const showQuickOrderLink = showQuickOrder && allowQuickOrder;
        const mainNavContextStyles = this?.context?.styles?.mainNavigation ?? {};
        const styles = mergeToNew(mainNavigationStyles, mainNavContextStyles);

        if (isCompactHeaderFlyoutMenu) {
            const flyoutCustomCssWrapper = {
                css: css`
                    ${flyoutCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...flyoutCustomCssWrapper}>
                    <StyledWrapper className="flyout-menu-wrapper" {...styles.compactFlyoutMenu}>
                        <NavigationDrawer
                            links={links}
                            showQuickOrder={showQuickOrderLink}
                            quickOrderLink={quickOrderLink}
                            displayVmiNavigation={displayVmiNavigation}
                            vmiPageLinks={vmiPageLinks}
                            displayModeSwitch={displayModeSwitch}
                            currentMode={currentMode}
                            isCompactHeaderFlyout={true}
                            id={id}
                            showFlyoutPricingToggle={showFlyoutPricingToggle}
                            showFlyoutInventoryToggle={showFlyoutInventoryToggle}
                            allowOpenParentLinks={openParentPages}
                        />
                    </StyledWrapper>
                </StyledWrapper>
            );
        }

        if (isCompactHeaderMainNavigation) {
            const mainNavigationCustomCSSWrapper = {
                css: css`
                    ${сompactHeaderMainNavigationCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...mainNavigationCustomCSSWrapper} className="wrapper" {...styles.contentWrapper}>
                    {displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            <StyledWrapper
                                className="item-wrapper"
                                {...styles.itemWrapper}
                                data-test-selector="vmiPageLinks"
                            >
                                {vmiPageLinks.map(
                                    link =>
                                        link && (
                                            <Link
                                                className="vmi-page-link"
                                                key={link.id}
                                                typographyProps={styles.menuItemTypography}
                                                color={styles.menuItemTypography?.color}
                                                {...styles.menuItem}
                                                id={link.id}
                                                href={link.url}
                                                data-test-selector={`vmiPageLink-${link.title.replace(/\s+/g, "")}`}
                                            >
                                                {link.title}
                                            </Link>
                                        ),
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                    {!displayVmiNavigation && (
                        <StyledWrapper
                            className="container"
                            {...styles.container}
                            ref={this.container}
                            data-test-selector="mainNavigationLinks"
                        >
                            {links.map((link, index) => {
                                return (
                                    <StyledWrapper
                                        className="item-wrapper"
                                        {...styles.itemWrapper}
                                        key={index}
                                        data-test-selector={`mainNavigationLink-${link.title.replace(/\s+/g, "")}`}
                                    >
                                        <MainNavigationItem
                                            index={index}
                                            link={link}
                                            styles={styles}
                                            container={this.container}
                                            isOpen={index === selectedLinkIndex}
                                            displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                        />
                                    </StyledWrapper>
                                );
                            })}
                            {showQuickOrderLink && quickOrderLink && (
                                <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                    <StyledWrapper
                                        className="quick-order-item-wrapper"
                                        {...styles.quickOrderItemWrapper}
                                    >
                                        <Link
                                            className="quick-order-link"
                                            typographyProps={styles.menuItemTypography}
                                            color={styles.menuItemTypography?.color}
                                            {...styles.menuItem}
                                            id="quickOrder"
                                            href={quickOrderLink.url}
                                        >
                                            {quickOrderLink.title}
                                        </Link>
                                    </StyledWrapper>
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            );
        }

        const customCssWrapper = {
            css: css`
                ${customCSS}
            `,
        };

        return (
            <StyledWrapper {...customCssWrapper}>
                <StyledWrapper className="mobile-wrapper" {...styles.mobileWrapper}>
                    <Hidden className="mobile-menu-wrapper" above="md" {...styles.mobileMenuWrapper}>
                        <NavigationDrawer
                            links={links}
                            showQuickOrder={showQuickOrderLink}
                            quickOrderLink={quickOrderLink}
                            displayVmiNavigation={displayVmiNavigation}
                            vmiPageLinks={vmiPageLinks}
                            displayModeSwitch={displayModeSwitch}
                            currentMode={currentMode}
                            id={id}
                            rootElementSelector=".mobile-menu-wrapper"
                            allowOpenParentLinks={openParentPages}
                        />
                    </Hidden>
                    <Hidden className="mobile-search-wrapper" above="sm" {...styles.mobileSearchWrapper}>
                        <Button
                            className="mobile-search-button"
                            {...styles.mobileSearchButton}
                            onClick={this.mobileSearchButtonClickHandler}
                        >
                            <ButtonIcon className="mobile-search-button-icon" src={Search} />
                            <VisuallyHidden>{translate("Search")}</VisuallyHidden>
                        </Button>
                    </Hidden>
                </StyledWrapper>
                <StyledWrapper className="wrapper" {...styles.mainWrapper}>
                    <Hidden below="lg" {...styles.contentWrapper}>
                        {!displayVmiNavigation && (
                            <StyledWrapperContainer
                                className="container"
                                {...styles.container}
                                website={website}
                                ref={this.container}
                            >
                                {links.map((link: any, index: number) => {
                                    const itemWrapper = {
                                        css: css`
                                            align-items: center;
                                            justify-content: flex-start;
                                            position: relative;
                                            overflow: visible;
                                            background: ${link.isBackground
                                                ? getColor("primary")
                                                : website === "tecumseh"
                                                  ? getColor("primary")
                                                  : getColor("secondary")};
                                            display: flex;
                                            padding-left: 18px;
                                            padding-right: 18px;
                                            min-height: 50px;
                                            &:hover span + div {
                                                display: block;
                                            }
                                            &:after {
                                                content: "";
                                                height: 60%;
                                                width: 1px;
                                                right: 0;
                                                top: 10px;
                                                position: absolute;
                                                background-color: ${website === "tecumseh"
                                                    ? "transparent"
                                                    : COLORS.background.base};
                                                z-index: 1;
                                            }

                                            &.item-wrapper__last {
                                                &:after {
                                                    display: none;
                                                }
                                            }
                                            .cascading-menu .mainMenu .myAccountSection {
                                                display: none;
                                            }

                                            .cascading-menu .mainMenu .menuItem .myAccountSection {
                                                display: none;
                                            }
                                            // &:last-child:after {
                                            //     display: none;
                                            // }
                                        `,
                                    };
                                    const lastElemClass =
                                        showSeperatorForLastElem && index === links.length - 1
                                            ? "item-wrapper__last"
                                            : "item-wrapper";
                                    return (
                                        <StyledWrapper
                                            className={`item-wrapper ${lastElemClass}`}
                                            {...itemWrapper}
                                            key={index}
                                            data-test-selector={`mainNavigationLink-${link.title.replace(/\s+/g, "")}`}
                                        >
                                            <MainNavigationItem
                                                index={index}
                                                link={link}
                                                styles={styles}
                                                container={this.container}
                                                isOpen={index === selectedLinkIndex}
                                                displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                            />
                                        </StyledWrapper>
                                    );
                                })}
                                {showQuickOrderLink && quickOrderLink && (
                                    <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                        <StyledWrapper
                                            className="quick-order-item-wrapper"
                                            {...styles.quickOrderItemWrapper}
                                        >
                                            <Link
                                                className="quick-order-link"
                                                typographyProps={styles.menuItemTypography}
                                                color={styles.menuItemTypography?.color}
                                                {...styles.menuItem}
                                                id="quickOrder"
                                                href={quickOrderLink.url}
                                            >
                                                {quickOrderLink.title}
                                            </Link>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}
                            </StyledWrapperContainer>
                        )}
                        {displayVmiNavigation && (
                            <StyledWrapper className="container" {...styles.container} ref={this.container}>
                                <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                    {vmiPageLinks.map(
                                        link =>
                                            link && (
                                                <Link
                                                    className="vmi-page-link"
                                                    key={link.id}
                                                    typographyProps={styles.menuItemTypography}
                                                    color={styles.menuItemTypography?.color}
                                                    {...styles.menuItem}
                                                    id={link.id}
                                                    href={link.url}
                                                    data-test-selector={`vmiNavigation_${link.title.replace(/\s+/g, "")}`}
                                                >
                                                    {link.title}
                                                </Link>
                                            ),
                                    )}
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                    </Hidden>
                </StyledWrapper>
                <Modal
                    className="mobile-search-modal"
                    {...styles.mobileSearchModal}
                    isOpen={this.state.mobileSearchModalIsOpen}
                    closeOnEsc={true}
                    handleClose={this.mobileSearchModalCloseHandler}
                    headline={
                        <SearchInput
                            id={id}
                            inputRef={this.mobileSearchInput}
                            autocompletePositionFunction={this.getMobileSearchAutocompletePosition}
                            onBeforeGoToUrl={this.mobileSearchModalCloseHandler}
                            extendedStyles={styles.mobileSearchInputStyles}
                        />
                    }
                />
            </StyledWrapper>
        );
    }
}

MainNavigation.contextType = StylesContext;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const mainNavigation: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MainNavigation),
    definition: {
        group: "Header",
        icon: "magnifying-glass",
        allowedContexts: ["Header"],
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                onEditRow: (index: number, dispatch) => {
                    dispatch({
                        type: "SendToSite/OpenMainNavigation",
                        index,
                    });
                },
                onDoneEditingRow: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                onLoad: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                getDisplay: (item: HasFields, state) => {
                    const { type, value } = item.fields.destination;
                    const { overrideTitle, title } = item.fields;
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return overrideTitle || link?.title;
                    }
                    if (type === "Category") {
                        if (overrideTitle) {
                            return overrideTitle;
                        }
                        if (value === emptyGuid) {
                            return "Products";
                        }
                        const categoryState = getCategoryState(state, value);
                        if (!categoryState.value) {
                            if (!categoryState.isLoading && value) {
                                return dispatch => {
                                    dispatch(
                                        loadCategory({
                                            id: value,
                                        }),
                                    );
                                };
                            }
                            return "";
                        }
                        return categoryState.value.shortDescription;
                    }
                    if (type === "Url") {
                        return title ?? value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "linkType",
                        editorTemplate: "RadioButtonsField",
                        defaultValue: "Link",
                        isRequired: true,
                        options: [
                            {
                                displayName: "Link",
                                value: "Link",
                            },
                            {
                                displayName: "Mega Menu",
                                value: "MegaMenu",
                            },
                            {
                                displayName: "Cascading Menu",
                                value: "CascadingMenu",
                            },
                        ],
                    },
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                        allowUrls: item => item.fields.linkType === "Link",
                        showCategoryRoot: item => true,
                    },
                    {
                        name: "overrideTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.destination.type !== "Url",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                        isVisible: item => item.fields.destination.type === "Url",
                    },
                    {
                        name: "isCustomMenu",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) =>
                            item.fields.linkType === "MegaMenu" || item.fields.linkType === "CascadingMenu",
                    },
                    {
                        name: "isBackground",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: () => true,
                    },
                    {
                        name: "isDcProduct",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: () => true,
                    },
                    // {
                    //     name: "customMenuTitle",
                    //     editorTemplate: "TextField",
                    //     defaultValue: "",
                    //     tab: basicTab,
                    //     isVisible: (item: HasFields) => item.fields.isCustomMenu === true,
                    // },
                    // {
                    //     name: "destination",
                    //     editorTemplate: "LinkField",
                    //     defaultValue: {
                    //         value: "",
                    //         type: "Page",
                    //     },
                    //     isRequired: true,
                    //     allowUrls: ()=> true,
                    //     showCategoryRoot: item => true,
                    //     tab: basicTab,
                    //     isVisible: (item: HasFields) => item.fields.isCustomMenu === true,
                    // },
                    {
                        name: "subMenuLinks",
                        editorTemplate: "ListField",
                        getDisplay: (mLink: HasFields) => {
                            return mLink.fields.subMenuTitle;
                        },
                        isVisible: (item: HasFields) => item.fields.isCustomMenu === true,
                        defaultValue: [],
                        fieldDefinitions: [
                            {
                                name: "subMenuTitle",
                                displayName: "subMenuTitle",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: "destination",
                                editorTemplate: "LinkField",
                                defaultValue: {
                                    value: "",
                                    type: "Page",
                                },
                                isRequired: true,
                                allowUrls: () => true,
                                showCategoryRoot: item => true,
                            },
                            {
                                name: "openInNewWindow",
                                editorTemplate: "CheckboxField",
                                defaultValue: false,
                            },
                            {
                                name: "colWidth",
                                editorTemplate: "TextField",
                                defaultValue: "150",
                                // isRequired: true,
                            },
                            {
                                name: "internalMenuLinks",
                                editorTemplate: "ListField",
                                getDisplay: (mLink: HasFields) => {
                                    return mLink.fields.internalMenuTitle;
                                },
                                defaultValue: [],
                                fieldDefinitions: [
                                    {
                                        name: "internalMenuTitle",
                                        displayName: "internalMenuTitle",
                                        editorTemplate: "TextField",
                                        defaultValue: "",
                                    },
                                    {
                                        name: "destination",
                                        editorTemplate: "LinkField",
                                        defaultValue: {
                                            value: "",
                                            type: "Page",
                                        },
                                        isRequired: true,
                                        allowUrls: () => true,
                                        showCategoryRoot: item => true,
                                    },
                                    {
                                        name: "openInNewWindow",
                                        editorTemplate: "CheckboxField",
                                        defaultValue: false,
                                    },
                                ],
                            },
                        ],
                        tab: basicTab,
                    },
                    {
                        name: "numberOfColumns",
                        editorTemplate: "DropDownField",
                        defaultValue: 6,
                        options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }],
                        // isRequired: true,
                        isVisible: (item: HasFields) => item.fields.linkType === "MegaMenu",
                    },
                    {
                        name: "flyoutContainerWidth",
                        editorTemplate: "TextField",
                        defaultValue: "500",
                        isVisible: (item: HasFields) =>
                            item.fields.linkType === "MegaMenu" && item.fields.numberOfColumns,
                    },
                    {
                        name: "maxDepth",
                        editorTemplate: "DropDownField",
                        defaultValue: 3,
                        options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }],
                        isRequired: true,
                        isVisible: (item: HasFields) => item.fields.linkType === "CascadingMenu",
                    },
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) => item.fields.linkType === "Link",
                    },
                ],
                tab: basicTab,
            },
            {
                name: fields.website,
                editorTemplate: "DropDownField",
                defaultValue: "tecumseh",
                fieldType: "General",
                options: [
                    {
                        displayName: "Tecumseh",
                        value: "tecumseh",
                    },
                    {
                        displayName: "Masterflux",
                        value: "masterflux",
                    },
                ],
                hideEmptyOption: true,
                sortOrder: 27,
            },
            {
                name: fields.showQuickOrder,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.openParentPages,
                displayName: "Open Parent Pages",
                tooltip:
                    "When enabled, tapping on a text link in the flyout menu will directly open the linked webpage and require users to click the chevron to access child pages. If disabled, tapping any link in the flyout menu will navigate to a submenu of child pages.",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: "showSeperatorForLastElem",
                displayName: "Show Seperator For Last Item",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default mainNavigation;
